import { render, staticRenderFns } from "./TopConsumers.vue?vue&type=template&id=0b37f39a&scoped=true&"
import script from "./TopConsumers.vue?vue&type=script&lang=js&"
export * from "./TopConsumers.vue?vue&type=script&lang=js&"
import style0 from "./TopConsumers.vue?vue&type=style&index=0&id=0b37f39a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b37f39a",
  null
  
)

export default component.exports